<template>
    <NuxtLayout>
        <div class="body-block">
            <div class="title-container">
                <div class="container-xl">
                    <div class="doc-title-container">
                        <div class="row">
                            <div class="col-sm-12 col-lg-6">
                                <h1 class="page_title mt-10">Что такое Cookie?</h1>
                            </div>
                            <div class="col-lg-6 d-none d-lg-block text-end">
                                <img src="/images/documents/document_view.png" alt="" class="doc-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="body-documents">
                <div class="container-xl">

                    <p>Cookie (куки) являются текстовым файлом, сохраненным в браузере компьютера (мобильного устройства)
                        пользователя официального интернет-сайта ТОО «ПЭК Казахстан» https://pecom.kz/ (далее – сайт) при его
                        посещении пользователем для отражения совершенных им действий. Этот файл позволяет не вводить заново или
                        выбирать те же параметры при повторном посещении сайта. Целью обработки куки является обеспечение удобства
                        пользователей сайта и повышение качества его функционирования, улучшение производительности, а также
                        статистика.</p><h4 class="">Какие файлы Cookie мы обрабатываем?</h4>
                    <p>1. Аналитические и маркетинговые: определяют предпочтения пользователей и позволяют хранить историю посещений
                        страниц сайта в целях повышения качества его функционирования, чтобы определить наиболее и наименее
                        популярные страницы. Например, мы можем анализировать страницы, которые вы посещаете, если у вас возникают
                        какие-либо ошибки, время загрузки.</p>
                    <p><br></p>
                    <p>Для обработки статистических файлов мы используем следующие сервисы:</p>
                    <p><b>Яндекс Метрика:</b></p>
                    <ul>
                        <li>сервис веб-аналитики, предоставляемый ООО «Яндекс».</li>
                        <li>адрес: г. Москва, ул. Льва Толстого, д. 16, 119021.</li>
                        <li>подробнее с информацией о сервисе можно ознакомиться здесь.</li>
                        <li>политика конфиденциальности Рейтинг Mail здесь.</li>
                    </ul>
                    <p>2. Поддержки: позволяют хранить историю переписки при общении в онлайн-чатах.</p>
                    <p>Для обработки файлов поддержки мы используем LiveTex:</p>
                    <ul>
                        <li>сервис связи с клиентами, предоставляемый ООО "Омниканальные Технологии"</li>
                        <li>191025, Санкт-Петербург г., Маяковского ул., дом 3Б, литера А, помещение 5-Н (30,31)</li>
                        <li>подробнее с информацией о сервисе можно ознакомиться здесь.</li>
                        <li>политика конфиденциальности LiveTex здесь.</li>
                    </ul>
                    <p>3. Технические: необходимы для нормальной работы сайта и не могут быть отключены. В данных файлах куки личная
                        информация не хранится.</p><h4 class="">Как включить/отключить обработку Cookie?</h4>
                    <p>Вы всегда можете запретить использование cookie в разделе меню "Параметры" или "Настройки". Если вам
                        требуется помощь, рекомендуем посетить ресурсы по приведенным ниже ссылкам. Вы также можете найти
                        дополнительную информацию в разделе "Справка" непосредственно в браузере.</p>
                    <ul>
                        <li>Параметры файлов cookie в браузере Internet Explorer</li>
                        <li>Параметры файлов cookie в браузере Microsoft Edge</li>
                        <li>Параметры файлов cookie в браузере Firefox</li>
                        <li>Параметры файлов cookie в браузере Chrome</li>
                        <li>Параметры файлов cookie в браузере Safari</li>
                    </ul>
                    <h4 class="">Как связаться с нами?</h4>
                    <p>Мы надеемся, что представленная в этой политике информация дает исчерпывающий ответ на вопрос, что такое
                        файлы cookie и для каких целей мы их используем. Если у вас возникнут другие вопросы или вам потребуются
                        дополнительные сведения, ознакомьтесь с нашей Политикой по обработке персональных данных или свяжитесь с
                        нами по адресу pnd@pecom.kz.</p>
                    </div>
                </div>
            </div>
    </NuxtLayout>
</template>

<script>
export default {
    name: "index"
}
</script>

<style scoped>

</style>
